module.exports = __webpack_public_path__ + "static/img/img-cp7-1.abaf63a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-cp7-1.png
// module id = XNxX
// module chunks = 0